import React, { useEffect, useState, useContext } from 'react'
import HeaderReturn from '../../../components.js/serveur/siteWeb/HeaderReturn'
import { Link } from 'react-router-dom'
import Spinner from '../../../components.js/elements/Spinner'
import useFirebase from './../../../firebase/useFirebase'
import { AppContext } from '../../../App'
import useForm from '../../../hooks/useForm'
import ViewClients from '../../../components.js/serveur/clients/ViewClients'
// IMAGES
import imageClients from '../../../images/clients.png'

const INITIAL_STATE = {
    name:'',
}

const Clients = () => {
    const [montage, setMontage] = useState(true)
    const [keyUid, setKeyUid] = useState(localStorage.getItem('keyUid'))
    const { updateData, readData, writeData, profil, services, staff, clients, booking, datesOff, count } = useFirebase()
    const { user } = useContext(AppContext)
    const { handleChange, values, refresh } = useForm(INITIAL_STATE)

    useEffect(() => { 
        readData(user.uid)   
    },[montage])

    if (montage === null) return <Spinner />

    return (
        <div className='container-fluid'>

            <HeaderReturn title='Clients' image={imageClients} link='/homeServeur'/>

            <ViewClients  
                values={values}
                clients={clients}
                handleChange={handleChange}
                refresh={refresh}
            />
        </div>
    )
} 

export default Clients


